import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("koptur_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // public
  heroImages: () => client.get("/hero-images").then((r) => r.data),
  sectors: () => client.get("/sectors").then((r) => r.data),
  news: () => client.get("/news").then((r) => r.data),
  newsItem: (id) => client.get(`/news/${id}`).then((r) => r.data),
  settings: () => client.get("/settings").then((r) => r.data),
  kurumsal: () => client.get("/kurumsal").then((r) => r.data),
  documents: () => client.get("/documents").then((r) => r.data),
  products: () => client.get("/products").then((r) => r.data),
  productBySlug: (slug) => client.get(`/products/${slug}`).then((r) => r.data),
  submitContact: (payload) => client.post("/contact", payload).then((r) => r.data),
  // auth
  login: (username, password) =>
    client.post("/auth/login", { username, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  changePassword: (current_password, new_password) =>
    client
      .post("/admin/change-password", { current_password, new_password })
      .then((r) => r.data),
  // admin
  createNews: (payload) => client.post("/admin/news", payload).then((r) => r.data),
  updateNews: (id, payload) => client.put(`/admin/news/${id}`, payload).then((r) => r.data),
  deleteNews: (id) => client.delete(`/admin/news/${id}`).then((r) => r.data),
  updateSector: (id, payload) =>
    client.put(`/admin/sectors/${id}`, payload).then((r) => r.data),
  addHeroImage: (url) => client.post("/admin/hero-images", { url }).then((r) => r.data),
  deleteHeroImage: (id) =>
    client.delete(`/admin/hero-images/${id}`).then((r) => r.data),
  listContacts: () => client.get("/admin/contacts").then((r) => r.data),
  deleteContact: (id) => client.delete(`/admin/contacts/${id}`).then((r) => r.data),
  updateSettings: (payload) =>
    client.put("/admin/settings", payload).then((r) => r.data),
  updateKurumsal: (payload) =>
    client.put("/admin/kurumsal", payload).then((r) => r.data),
  createDocument: (payload) =>
    client.post("/admin/documents", payload).then((r) => r.data),
  deleteDocument: (id) =>
    client.delete(`/admin/documents/${id}`).then((r) => r.data),
  createProduct: (payload) =>
    client.post("/admin/products", payload).then((r) => r.data),
  updateProduct: (id, payload) =>
    client.put(`/admin/products/${id}`, payload).then((r) => r.data),
  deleteProduct: (id) =>
    client.delete(`/admin/products/${id}`).then((r) => r.data),
  stats: () => client.get("/admin/stats").then((r) => r.data),
};
